function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { generateID } from '@stripe-internal/analytics-js/dist/src/utils/string';
import { LegacyStripeAnalyticsProvider } from './provider/LegacyStripeAnalytics';
import { GoogleTagManagerProvider } from './provider/GoogleTagManager';
import { Client } from './Client';
import { ConsoleLogger } from './logger/Console';
import { VoidLogger } from './logger/Void';
import { ConsoleProvider } from './provider/Console';
import { PrivacyComplianceProvider } from './provider/PrivacyCompliance';
import { StripeAnalyticsProvider } from './provider/StripeAnalytics';
import { isDevelopment } from './environment';
function createLogger(environment) {
    if (isDevelopment(environment)) {
        return ConsoleLogger;
    } else {
        return VoidLogger;
    }
}
const getProviders = ({ gtmId, gtmFrameUrl, environment, logger, getLocaleInfo, aelClientId, aelNamespace, deferLoading = false, sessionizationDomain })=>{
    const providers = [];
    if (gtmId && gtmFrameUrl) {
        providers.push(new GoogleTagManagerProvider({
            gtmId,
            frameUrl: gtmFrameUrl,
            deferLoading
        }));
        providers.push(new PrivacyComplianceProvider(gtmFrameUrl));
    } else {
        logger.error('[Analytics] No Google Tag Manager ID or frame URL found on page, cannot load Google Tag Manager');
    }
    // TODO(mdg): do not generate the ID here once we have removed the legacy provider.
    // it is only needed to sync the ID between AE and AEL
    const pageViewToken = generateID();
    providers.push(new LegacyStripeAnalyticsProvider(environment, pageViewToken, getLocaleInfo, aelClientId, aelNamespace));
    providers.push(new StripeAnalyticsProvider(environment, pageViewToken, getLocaleInfo, aelClientId, aelNamespace, sessionizationDomain));
    if (isDevelopment(environment)) {
        providers.push(new ConsoleProvider(logger));
    }
    return providers;
};
export function createClient(config) {
    const logger = createLogger(config.environment);
    return new Client({
        providers: getProviders(_object_spread_props(_object_spread({}, config), {
            logger
        })),
        patchMismatchedCids: config.patchMismatchedCids,
        logger
    });
}

//# sourceMappingURL=createClient.js.map